module.exports = __webpack_public_path__ + "img/town-grey.4df85ebf.png";